import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImagePreviewPopupComponent } from 'src/app/shared/image-preview-popup/image-preview-popup.component';
import { Context } from 'src/app/shared/models/context';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { KycApprover } from 'src/app/shared/models/dossier';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { DossierKycService } from 'src/app/shared/services/dossier-kyc.service';

@Component({
  selector: 'app-kyc-approval',
  templateUrl: './kyc-approval.component.html',
  styleUrls: ['./kyc-approval.component.scss']
})
export class KycApprovalComponent implements OnInit {
 @ViewChildren('fileInput') fileInputs!: QueryList<ElementRef<HTMLInputElement>>;
  public kycs: any[] = [];
  public isLoading: boolean = true;
  public submitted: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  private context: Context;
  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private dossierService: DossierKycService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.context = this.authService.getContextData();
    if (this.context && this.context?.employeeId) {
      this.getKycs();
    }
  }

  private getKycs(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.kycs = [];
      }
      this.dossierService.getApproverKycs(this.context.employeeId).subscribe({
        next: (response: any) => {
          const groupedArray: any[] = [];
  
          for (const [employeeKey, documents] of Object.entries(response)) {
            const employeeKyc: any = {
              employeeName: employeeKey,
              PAN: null,
              AADHAAR: null,
              PASSPORT: null,
              status: 'PENDING'
            };
              const documentsArray = documents as any[];
              const allCompleted = documentsArray.every((doc) => doc.status === 'COMPLETED');
              for (const doc of documentsArray) {
              const type = doc.type?.toUpperCase();
              if (type === 'PAN') employeeKyc.PAN = doc;
              else if (type === 'AADHAAR') employeeKyc.AADHAAR = doc;
              else if (type === 'PASSPORT') employeeKyc.PASSPORT = doc;
            }
              if (allCompleted) {
              employeeKyc.status = 'COMPLETED';
            }
  
            groupedArray.push(employeeKyc);
          }
  
          this.kycs = groupedArray;
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }
  

  public upsertkyc(kyc: any) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(ImagePreviewPopupComponent, { size: 'md', centered: true });
    modalRef.componentInstance.documentUrl = kyc.documentFileUrl;
    modalRef.componentInstance.type = kyc.type;
  }
}
